module.exports = __webpack_public_path__ + "img/pipeline-outline-icon.df28702f.svg";